var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Form', {
    ref: "form",
    staticClass: "mt-20",
    attrs: {
      "model": _vm.form,
      "inline": _vm.inline,
      "rules": _vm.rules,
      "label-position": _vm.labelPosition,
      "label-width": _vm.labelWidth
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return (function () {})($event)
      }
    }
  }, [_vm._l((_vm.formItem), function(item) {
    return _c('FormItem', {
      key: item.prop,
      attrs: {
        "prop": item.prop,
        "required": item.required,
        "label": item.label + ':'
      }
    }, [(item.labelSlot) ? _c('label', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("\n       " + _vm._s(item.label) + "：\n       "), _c('BaseTooltip', {
      attrs: {
        "placement": "top",
        "content": item.tip
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type === 'select') ? [_c('Select', {
      staticClass: "form-item",
      on: {
        "on-change": function($event) {
          return _vm.change($event, item.prop)
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }, _vm._l((_vm.formExtraConfig[item.configKey]), function(config) {
      return _c('Option', {
        key: config.id,
        attrs: {
          "value": config.id
        }
      }, [_vm._v(_vm._s(config.label))])
    }), 1)] : (item.type === 'input') ? [_c('Input', {
      staticClass: "form-item",
      attrs: {
        "placeholder": item.placeholder,
        "icon": item.enterSearch ? 'ios-search' : '',
        "maxlength": item.maxLength
      },
      on: {
        "on-click": function($event) {
          return _vm.inputEnterSearch(_vm.form[item.prop], item.prop, item.enterSearch)
        },
        "on-enter": function($event) {
          return _vm.inputEnterSearch(_vm.form[item.prop], item.prop, item.enterSearch)
        },
        "on-blur": function($event) {
          return _vm.change($event, item.prop)
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }), _vm._v(" "), (item.desc) ? _c('span', [_vm._v(_vm._s(item.desc))]) : _vm._e()] : (item.type === 'textarea') ? [_c('Input', {
      staticClass: "form-item",
      attrs: {
        "placeholder": item.placeholder,
        "type": "textarea",
        "maxlength": item.maxLength,
        "show-word-limit": ""
      },
      on: {
        "on-blur": function($event) {
          return _vm.change($event, item.prop)
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }), _vm._v(" "), (item.desc) ? _c('span', [_vm._v(_vm._s(item.desc))]) : _vm._e()] : (item.type === 'radio') ? [_c('RadioGroup', {
      on: {
        "on-change": function($event) {
          return _vm.change($event, item.prop)
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }, _vm._l((_vm.formExtraConfig[item.configKey]), function(config) {
      return _c('Radio', {
        key: config.id,
        attrs: {
          "label": config.id,
          "disabled": config.disabled
        }
      }, [_vm._v("\n             " + _vm._s(config.label) + "\n           ")])
    }), 1)] : (item.type === 'checkbox') ? [_c('CheckboxGroup', {
      on: {
        "on-change": function($event) {
          return _vm.change($event, item.prop)
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }, _vm._l((_vm.formExtraConfig[item.configKey]), function(config) {
      return _c('Checkbox', {
        key: config.id,
        attrs: {
          "disabled": config.disabled,
          "label": config.id
        }
      }, [_vm._v(_vm._s(config.label))])
    }), 1)] : (item.type === 'upload') ? _c('div', [_c('Upload', {
      ref: "upload",
      refInFor: true,
      attrs: {
        "max-size": item.uploadSize,
        "format": ['jpg', 'jpeg', 'png', 'bmp'],
        "on-format-error": _vm.handleFormatError,
        "data": _vm.uploadConfig,
        "show-upload-list": false,
        "on-success": _vm.uploadSuccess,
        "on-exceeded-size": function (v) {
          _vm.checkImageSize(v, item.uploadSize)
        },
        "on-progress": _vm.imageProgress,
        "action": "//upload.qiniup.com/"
      }
    }, [(!_vm.form[item.prop]) ? _c('div', {
      staticClass: "upload-wrap flex flex-center align-center cur-p",
      on: {
        "click": function($event) {
          return _vm.refreshUploadToken(item.prop)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-add",
        "size": "24"
      }
    })], 1) : _c('img', {
      staticClass: "upload-wrap upload-img",
      attrs: {
        "src": _vm.form[item.prop]
      },
      on: {
        "click": function($event) {
          return _vm.refreshUploadToken(item.prop)
        }
      }
    })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.desc))]), _vm._v(" "), (_vm.form[item.prop] && item.isDelete) ? _c('div', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#20bf64"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImage(item.prop)
        }
      }
    }, [_vm._v("删除图片")]) : _vm._e()], 1) : (item.type === 'switch') ? [_c('i-switch', {
      on: {
        "on-change": function($event) {
          return _vm.change($event, item.prop)
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    })] : _c('div', [_vm._v(_vm._s(_vm.form[item.prop]))]), _vm._v(" "), _vm._t(item.prop)], 2)
  }), _vm._v(" "), (_vm.showButton) ? _c('div', {
    staticClass: "footer-spl"
  }) : _vm._e(), _vm._v(" "), (_vm.showButton) ? _c('FormItem', {
    staticClass: "footer flex",
    class: _vm.btnAlign === 'right' ? ' flex-end' : ''
  }, [_c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])], 1) : _vm._e()], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3299cbc3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3299cbc3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseForm/index.vue
// module id = vnE8
// module chunks = 142